import { render } from "./EmptyResults.vue?vue&type=template&id=30ff43ad"
import script from "./EmptyResults.vue?vue&type=script&lang=js"
export * from "./EmptyResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__